﻿export function camel(s: string): string {
    return s.charAt(0).toLowerCase() + s.slice(1);
}

export function pascal(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function camelCase(s: string): string {
    return s
        .split(' ')
        .map((word, i) =>
            i === 0
                ? word.charAt(0).toLowerCase() + word.slice(1).toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
}

export function pascalCase(s: string): string {
    return s
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
}

export function format(s: string, ...args: any[]): string {
    if (!args || args.length === 0)
        return s;

    return s.replace(/(\{(\d+?)\})/g, ($0, $1, $2) => {
        var i = parseInt($2, 10);
        if (i < args.length) {
            return args[i];
        } else {
            throw 'The number indicating an argument to be formatted (' + i + ') is larger than or equal to the number of the format arguments.';
        }
    });
}

export function endsWith(str: string, suffix: string): boolean {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

export function escapeRegex(s): string {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

export function htmlEncode(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

export function htmlDecode(str) {
    return str
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
}

export function bestGuessSpaces(s: string): string {
    const parts = s.split(/([A-Z]+(?=$|[A-Z][a-z])|[A-Z]?[a-z]+)/g).filter(x => x !== '');
    return parts.join(' ');
}

export function undefinedNullOrEmpty(s: string) {
    return s === undefined || s === null || s === '';
}

export function delimitedStringToArray(s, d) {
    const arr = [];
    let quote = false;  // true means we're inside a quoted field

    // iterate over each character, keep track of current row and column (of the returned array)
    for (let row = 0, col = 0, c = 0; c < s.length; c++) {
        const cc = s[c], nc = s[c+1];          // current character, next character
        arr[row] = arr[row] || [];             // create a new row if necessary
        arr[row][col] = arr[row][col] || '';   // create a new column (start with empty string) if necessary

        // If the current character is a quotation mark, and we're inside a
        // quoted field, and the next character is also a quotation mark,
        // add a quotation mark to the current column and skip the next character
        if (cc === '"' && quote && nc === '"') { arr[row][col] += cc; ++c; continue; }  

        // If it's just one quotation mark, begin/end quoted field
        if (cc === '"') { quote = !quote; continue; }

        // If it's a delimiter and we're not in a quoted field, move on to the next column
        if (cc === d && !quote) { ++col; continue; }

        // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
        // and move on to the next row and move to column 0 of that new row
        if (cc === '\r' && nc === '\n' && !quote) { ++row; col = 0; ++c; continue; }

        // If it's a newline (LF or CR) and we're not in a quoted field,
        // move on to the next row and move to column 0 of that new row
        if (cc === '\n' && !quote) { ++row; col = 0; continue; }
        if (cc === '\r' && !quote) { ++row; col = 0; continue; }

        // Otherwise, append the current character to the current column
        arr[row][col] += cc;
    }
    return arr;
}